import React from "react";
import * as Tools from "../../../../../helpers/Tools";
import SummaryItemGroup from "./SummaryItemGroup";

const CareGapDontNeed = ({ selectedNoCareGapReason, careGapTitle, careGapDateTitle }) => {

    const currentPath = location?.pathname;
    const basePath = currentPath?.substring(0, currentPath?.lastIndexOf('/') + 1); 
    const reason = [
        {
            title: `${careGapTitle}`,
            info: `${selectedNoCareGapReason?.selectedReason}`,
            pageUrl: `${basePath}updatehistory`
        }];

    const getReasonDetails = (selectedReason) => {
        switch (selectedReason) {
            case "Other":
                return [{
                    title: "Your comments",
                    info: `${selectedNoCareGapReason?.description ? selectedNoCareGapReason?.description : 'None'}`,
                    pageUrl: `${basePath}updatehistory`
                }];
                break;
            case "I already scheduled an appointment":
            case 'I have already scheduled an appointment':
                const reasonDetails = [];

                if (selectedNoCareGapReason?.data?.procedureMonth || selectedNoCareGapReason?.data?.procedureYear) {
                    reasonDetails.push({
                        title: `${careGapDateTitle}`,
                        info: `${selectedNoCareGapReason?.data?.procedureMonth ? Tools.getFullMonthName(selectedNoCareGapReason?.data?.procedureMonth) : ""} ${selectedNoCareGapReason?.data?.procedureYear ? selectedNoCareGapReason?.data?.procedureYear : ""}`,
                        pageUrl: `${basePath}updatehistory`
                    });
                }

                if (selectedNoCareGapReason?.data?.facilityName || selectedNoCareGapReason?.data?.phoneNumber) {
                    reasonDetails.push({
                        title: "Facility",
                        info: <>
                            {selectedNoCareGapReason?.data?.facilityName && <div>{selectedNoCareGapReason?.data?.facilityName}</div>}
                            {selectedNoCareGapReason?.data?.phoneNumber && <div>{selectedNoCareGapReason?.data?.phoneNumber}</div>}
                        </>,
                        pageUrl: `${basePath}updatehistory`
                    });
                }

                return reasonDetails;
                break;
            default:
                return [];
                break;
        }
    };

    const reasonDetails = getReasonDetails(selectedNoCareGapReason?.selectedReason);

    const summaryItems = reasonDetails && reasonDetails.length > 0 ? reason.concat(reasonDetails) : reason;

    return (<SummaryItemGroup
        summaryItems={summaryItems}
    />
   );
};

export default CareGapDontNeed;